module.exports = __webpack_public_path__ + "static/img/process.43e7cc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/process.png
// module id = ebu8
// module chunks = 1